export default __webpack_public_path__ + "static/media/download.a616b9d2.svg";